import { combineReducers } from '@reduxjs/toolkit';

import { accessTagsApi } from '~support-at-home/actions/accessTags';
import { acoBudgetsApi } from '~support-at-home/actions/acoBudgets';
import { budgetsApi } from '~support-at-home/actions/budgets';
import { budgetTrackerApi } from '~support-at-home/actions/budgetTracker';
import { claimsApi } from '~support-at-home/actions/claims';
import { clientHcpUnspentFundsApi } from '~support-at-home/actions/clientHcpUnspentFunds';
import { clientInvoicesApi } from '~support-at-home/actions/clientInvoices';
import { reconciliationsApi } from '~support-at-home/actions/reconciliations';
import { sahServiceTypeAssociationsApi } from '~support-at-home/actions/sahServiceTypeAssociations';
import { statementsApi } from '~support-at-home/actions/statements';
import { supplierInvoicesApi } from '~support-at-home/actions/supplierInvoices';
import { userTagsApi } from '~support-at-home/actions/userTags';

import accountCodes from './accountCodes';
import budgetServices from './budgetServices';
import classifications from './classifications';
import clientBudgetStatuses from './clientBudgetStatuses';
import clientClassifications from './clientClassifications';
import clientContributions from './clientContributions';
import clientServices from './clientServices';
import clientsWithBudgets from './clientsWithBudgets';
import externalApiStatuses from './externalApiStatuses';
import fundingTypes from './fundingTypes';
import pricePlanRevisions from './pricePlanRevisions';
import pricePlans from './pricePlans';
import sahBudgets from './sahBudgets';
import sahServiceTypeAssociations from './sahServiceTypeAssociations';
import supplierInvoices from './supplierInvoices';
import suppliers from './suppliers';

export const supportAtHome = {
  accountCodes,
  budgetServices,
  classifications,
  clientBudgetStatuses,
  clientClassifications,
  clientContributions,
  clientServices,
  externalApiStatuses,
  pricePlanRevisions,
  pricePlans,
  sahBudgets,
  sahServiceTypeAssociations,
  supplierInvoices,
  suppliers,
  clientsWithBudgets,
  fundingTypes,
};

export default combineReducers(supportAtHome);

export const supportAtHomeApis = [
  accessTagsApi,
  budgetsApi,
  budgetTrackerApi,
  claimsApi,
  clientInvoicesApi,
  clientHcpUnspentFundsApi,
  reconciliationsApi,
  acoBudgetsApi,
  sahServiceTypeAssociationsApi,
  statementsApi,
  supplierInvoicesApi,
  userTagsApi,
] as const;
